import { render } from "./Tooltip.vue?vue&type=template&id=28e6cbba"
import script from "./Tooltip.vue?vue&type=script&lang=js"
export * from "./Tooltip.vue?vue&type=script&lang=js"

import "./Tooltip.vue?vue&type=style&index=0&id=28e6cbba&lang=scss"
script.render = render

export default script